'use client';

import { parseAsString, useQueryState } from 'nuqs';
import { useEffect } from 'react';
import { MODAL_PARAM } from '@/modals/consts';
import { openVpnDetectedModal, VPN_DETECTED_MODAL } from '@/modals/utils/openVpnDetectedModal';
import { useUserMeQuery } from '@/queries/user/user.queries';
import { shouldOpenVpnModalForUser } from '@/queries/user/user.sockets';
import { useAppSelector } from '@/redux/hooks';

/**
 * Keeps the VPN-detected modal open while the user is flagged. Browser Back,
 * route changes or another modal replacing it all drop the modal param, so
 * reopen it whenever it is not the active modal.
 */
export default function VpnDetectedModalGuard() {
  const userSession = useAppSelector(state => state.user.userSession);
  const { data: user } = useUserMeQuery();
  const [modalParam] = useQueryState(MODAL_PARAM, parseAsString.withDefault(''));
  const isVpnBlocked = Boolean(userSession) && shouldOpenVpnModalForUser(user);

  useEffect(() => {
    if (isVpnBlocked && modalParam !== VPN_DETECTED_MODAL) {
      openVpnDetectedModal();
    }
  }, [isVpnBlocked, modalParam]);

  return null;
}
